import {Router} from "@angular/router";

type EnumType<T> = { [K in keyof T]: T[K] };
export class Utils {
  public reloadComponent(router: Router): void {
    // Get the current route URL
    const currentUrl = router.url;

    // Navigate to the same route again
    router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      router.navigate([currentUrl]);
    });
  }
  static getKeyByValue<T>(enumType: EnumType<T>, value: string | undefined): keyof T | string {
    const keys = Object.keys(enumType) as Array<keyof T>;
    let key =  keys.find(key => enumType[key] === value)
    if(key !=null){
    return key
    } else {
      return 'NA'
    }
  }

}
